<template>
  <PageMain v-if="info" class="order-detail bg-w mt-20 pd-20">
    <div class="fs-20 fs-b f-c-b mb-20">订单详情</div>
    <div>
      <div class="title">订单信息</div>
      <a-row class="fslh-32">
        <a-col :span="12"><span class="fs-12 f-c-b3">订单类型：</span><span class="fs-12 f-c-b1">{{ +info.isSecretOrder?'个人寄件':'因公寄件' }}</span></a-col>
        <a-col :span="12"><span class=" fs-12 f-c-b3">订单状态：</span><span class="fs-12 f-c-b1">{{ info.orderStateName }} {{ info.orderStateTime||'' }}</span></a-col>
      </a-row>
      <a-row class="fslh-32">
        <a-col :span="12"><span class="fs-12 f-c-b3">订单编号：</span><span class="fs-12 f-c-b1">{{ info.orderCode }}</span><span class="ml-10 fs-12 f-c-b3">下单时间：</span><span class="fs-12 f-c-b1">{{ info.createTime }}</span></a-col>
        <a-col :span="12"><span class="fs-12 f-c-b3">下单账号：</span><span class="fs-12 f-c-b1">{{ info.customerName }} {{ info.customerMobile?'('+info.customerMobile+')':'' }}</span></a-col>
      </a-row>
      <div class="  h-32 fslh-32"><span class="fs-12 f-c-b3">预约取件时间：</span><span class="fs-12 f-c-b1">{{ info.startDate }}&nbsp;~&nbsp;{{ info.endDate }}</span>
        <!-- <span v-if="!showTime" class="pointer f-c-blue ml-20" @click="showTime = true">修改取件时间</span> -->
        <ChangeTime v-if="showTime" class="ml-10" :order-code="info.orderCode" :shipper-code="info.shipperCode" @cancel="showTime = false" @success="onSuccess" />
      </div>

      <div class="h-32 fslh-32"><span class="fs-12 f-c-b3">寄件信息：</span><span class="fs-12 f-c-b1">{{ info.fromName }} {{ info.fromMobile }} {{ info.fromProvinceName }}{{ info.fromCityName }}{{ info.fromExpAreaname }}{{ info.fromAddress }}</span> </div>
      <div class="h-32 fslh-32"><span class="fs-12 f-c-b3">收件信息：</span><span class="fs-12 f-c-b1">{{ info.toName }} {{ info.toMobile }} {{ info.toProvinceName }}{{ info.toCityName }}{{ info.toExpAreaname }}{{ info.toAddress }}</span> </div>
      <div class="v-line mb-20 mt-20" />
      <div class="title">物流信息</div>
      <div class=" fslh-32">
        <a-row>
          <a-col :span="12"><span class="fs-12 f-c-b3">物品信息：</span><span class="fs-12 f-c-b1">{{ dealGoods(info.goods) }}</span></a-col>
          <a-col :span="12"><span class=" fs-12 f-c-b3">快递公司：</span><span class="fs-12 f-c-b1">{{ info.shipperName }}</span></a-col>
        </a-row>
        <a-row>
          <a-col :span="12"><span class="fs-12 f-c-b3">揽收重量：</span><span class="fs-12 f-c-b1">{{ info.weight }}</span></a-col>
          <a-col :span="12"><span class=" fs-12 f-c-b3">收点网点：</span><span class="fs-12 f-c-b1">{{ info.fromStationName|| '--' }}</span></a-col>
        </a-row>
        <a-row>
          <a-col :span="12"><span class="fs-12 f-c-b3">包裹件数：</span><span class="fs-12 f-c-b1">{{ info.quantity }}</span></a-col>
          <a-col :span="12"><span class=" fs-12 f-c-b3">揽件快递员：</span><span class="fs-12 f-c-b1">{{ info.fromPersonName|| '--' }} {{ info.fromPersonMobile }}</span></a-col>
        </a-row>
        <a-row>
          <a-col :span="12"><span class="fs-12 f-c-b3">备注：</span><span class="fs-12 f-c-b1">{{ info.remark || '--' }}</span></a-col>
          <a-col :span="12"><span class=" fs-12 f-c-b3">取件码：</span><span class="fs-12 f-c-b1">{{ info.pickupCode||'--' }}</span></a-col>
        </a-row>
        <a-row>
          <a-col :span="12"><span class="fs-12 f-c-b3">物流状态：</span><span class="fs-12 f-c-b1">{{ info.orderStateName }}</span></a-col>
          <a-col :span="12"><span class=" fs-12 f-c-b3">运单号：</span><span class="fs-12 f-c-b1">{{ info.logisticCode }}</span></a-col>

        </a-row>
        <!-- <span class="fs-12 f-c-b3">快递公司：</span><span class="fs-12 f-c-b1">{{ info.shipperName }}</span>
        <span class="ml-20 fs-12 f-c-b3">重量：</span><span class="fs-12 f-c-b1">{{ info.weight }}kg</span>
        <span class="ml-20 fs-12 f-c-b3">物品信息：</span><span class="fs-12 f-c-b1" />
        <span class="ml-20 fs-12 f-c-b3">快递员：</span><span class="fs-12 f-c-b1">{{ info.fromPersonName }} {{ info.fromPersonMobile }}</span> -->
      </div>
      <!-- <div class="h-32 fslh-32">
        <span class=" fs-12 f-c-b3">订单状态：</span><span class="fs-12 f-c-b1">{{ info.orderStateName }}</span>
      </div> -->
      <div class="v-line mb-20 mt-20" />

      <div class="title">支付信息</div>
      <div class=" fslh-32">
        <div>
          <span class=" fs-12 f-c-b3">支付方式：</span><span class="fs-12 f-c-b1">{{ info.payTypeName||'--' }}</span>
        </div>
        <div>
          <span class="fs-12 f-c-b3">支付费用：</span><span class="fs-12 f-c-b1">{{ info.custPayFreight||0 }}元</span>
        </div>
        <div>
          <span class=" fs-12 f-c-b3">支付时间：</span><span class="fs-12 f-c-b1">{{ info.payTime||'--' }}</span>
        </div>
        <div>
          <span class=" fs-12 f-c-b3">费用归属：</span><span class="fs-12 f-c-b1">{{ info.departmentId||'--' }}</span>
        </div>
      </div>
      <div class="v-line mb-20 mt-20" />

      <div class="title">其他</div>
      <div v-if="info.tickets">
        <div v-for="i in info.tickets" :key="i.id" class="flex mt-10">
          <div class="flex1 flex">
            <div class="w-70 ">投诉内容：</div>
            <div class="w-250 bg-grey reply">
              <div class="f-c-b3">{{ i.createTime }}</div>
              <div class="fs-b">
                {{ i.ticketContent }}
              </div>
              <div v-if="i.ticketPic">
                <a v-for="(item,index) in getPics(i.ticketPic)" :key="index" class="mr-5" target="_blank" :href="item">附件</a>
              </div>
            </div>
          </div>
          <div class="flex1 flex">
            <div class="w-70 ">投诉回复：</div>
            <div class="w-250 bg-grey reply">
              <div class="f-c-b3">{{ i.dealTime }}</div>
              <div class="fs-b">
                {{ i.dealResult||'--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>无</div>
      <div class="v-line mb-20 mt-20" />
      <div class="t-right">
        <a-button @click="viz = true">物流投诉</a-button>
      </div>

    </div>
    <Complaint :info="info" :visible.sync="viz" @success="postSuccess" />
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import ChangeTime from '../search/changeTime'
import Complaint from '@/components/complaint'
export default {
  name: 'Helloworld',
  components: {
    ChangeTime, Complaint
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      viz: false,
      showTime: false,
      info: null

    }
  },
  async created() {
    // 组件创建时，这个函数就会被触发
    if (!this.$route.query.kdnOrderCode) {
      this.$router.back()
      return
    }
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$http(this.$api.orderGetOne, {
        kdnOrderCode: this.$route.query.kdnOrderCode
      })
      this.info = res
    },
    dealGoods(goods) {
      if (goods && goods.length > 0) {
        return goods.map(el => el.goodsName).join(',')
      }
      return ''
    },
    onSuccess() {
      this.showTime = false
      this.getData()
    },
    postSuccess() {
      this.viz = false
      this.getData()
    },
    getPics(str) {
      if (!str) {
        return []
      }
      const list = str.split(',').filter(ele => ele)
      return list
    }
  }
}
</script>

<style lang="scss" >
.order-detail {
    .v-line{
        height: 1px;
        width: 100%;
        background: #dedede;
    }
    .reply{
        border-radius: 2px;
        padding: 10px;
    }
    .title{
        font-size: 16px;
        font-weight: bold;
        padding-left: 10px;
        position: relative;
        &::after{
            position: absolute;
            top: 4px;
            left: 0;
            content: "";
            width: 2px;
            height: 16px;
            background: #1890FF;
            display: block;
        }
    }
}
</style>
